(() => {
const $00bd06558984a7ef$var$utilities = {
    async getElementClientWidth (selector) {
        const el = document.querySelector(selector);
        return el ? el.clientWidth : null;
    }
};
window.utilities = $00bd06558984a7ef$var$utilities;

})();
//# sourceMappingURL=utilities.js.map
